import { useState } from 'react'

import { EMPTY_STRING } from '../../../../constants/common'
import { TextareaOutlineField, TextareaSkeleton } from '../../../Textarea'
import { Container } from '../../Container'
import {
  TEXTAREAS_ERROR_TEXT,
  TEXTAREAS_HELP_TEXT,
  TEXTAREAS_INFO,
  TEXTAREAS_LABEL,
  TEXTAREAS_MAX_LENGTH,
  TEXTAREAS_MIN_ROWS,
  TEXTAREAS_PLACEHOLDER,
  TEXTAREAS_VALUE,
} from '../Textareas.constants'

import * as styles from './TextareasOutline.module.css'

function TextareasOutline() {
  const [value, setValue] = useState(EMPTY_STRING)

  function voidHandleChange() {
    return
  }

  return (
    <>
      <Container label='Fully testable textarea with auto resize, required, with help text, with info, with counter, height - 96px, min width - 160px'>
        <TextareaOutlineField
          autoResizeHeight
          clearable
          required
          helpText={TEXTAREAS_HELP_TEXT}
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
          value={value}
          onChange={setValue}
        />
      </Container>

      <Container label='Textarea, min height - 96px, min width - 160px'>
        <TextareaOutlineField
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea without resize button with auto resize height, min height - 96px, min width - 160px'>
        <TextareaOutlineField
          autoResizeHeight
          withoutManualResize
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea without resize button and without auto resize height, min height - 96px, min width - 160px'>
        <TextareaOutlineField
          withoutManualResize
          label={TEXTAREAS_LABEL}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with error, min height - 96px, min width - 160px'>
        <TextareaOutlineField
          error={TEXTAREAS_ERROR_TEXT}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, disabled, min height - 96px, min width - 160px'>
        <TextareaOutlineField
          disabled
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, disabled, with value min height - 96px, min width - 160px'>
        <TextareaOutlineField
          disabled
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
          value={TEXTAREAS_VALUE}
          onChange={voidHandleChange}
        />
      </Container>
      <Container label='Textarea, required, height - 96px, min width - 160px'>
        <TextareaOutlineField
          required
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with help text, min height - 96px, min width - 160px'>
        <TextareaOutlineField
          helpText={TEXTAREAS_HELP_TEXT}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with help text, disabled, min height - 96px, min width - 160px'>
        <TextareaOutlineField
          disabled
          helpText={TEXTAREAS_HELP_TEXT}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with help text, disabled, with value, min height - 96px, min width - 160px'>
        <TextareaOutlineField
          disabled
          helpText={TEXTAREAS_HELP_TEXT}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
          value={TEXTAREAS_VALUE}
          onChange={voidHandleChange}
        />
      </Container>
      <Container label='Textarea, with help text, with error, min height - 96px, min width - 160px'>
        <TextareaOutlineField
          error={TEXTAREAS_ERROR_TEXT}
          helpText={TEXTAREAS_HELP_TEXT}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with info, height - 96px, min width - 160px'>
        <TextareaOutlineField
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with counter, with value height - 96px, min width - 160px'>
        <TextareaOutlineField
          clearable
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
          value={TEXTAREAS_VALUE}
          onChange={voidHandleChange}
        />
      </Container>
      <Container label='Textarea, required, with help text, height - 96px, min width - 160px'>
        <TextareaOutlineField
          required
          helpText={TEXTAREAS_HELP_TEXT}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, required, with help text, with info, height - 96px, min width - 160px'>
        <TextareaOutlineField
          required
          helpText={TEXTAREAS_HELP_TEXT}
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, required, with help text, with counter, height - 96px, min width - 160px'>
        <TextareaOutlineField
          required
          helpText={TEXTAREAS_HELP_TEXT}
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, required, with info, height - 96px, min width - 160px'>
        <TextareaOutlineField
          required
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, required, with info, with counter, height - 96px, min width - 160px'>
        <TextareaOutlineField
          required
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, required, with counter, height - 96px, min width - 160px'>
        <TextareaOutlineField
          required
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, required, with help text, with info, with counter, height - 96px, min width - 160px'>
        <TextareaOutlineField
          required
          helpText={TEXTAREAS_HELP_TEXT}
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, required, with help text, with info, with counter, height - 96px, min width - 160px'>
        <TextareaOutlineField
          required
          error={TEXTAREAS_ERROR_TEXT}
          helpText={TEXTAREAS_HELP_TEXT}
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with help text, with info, height - 96px, min width - 160px'>
        <TextareaOutlineField
          helpText={TEXTAREAS_HELP_TEXT}
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with help text, with counter, height - 96px, min width - 160px'>
        <TextareaOutlineField
          clearable
          helpText={TEXTAREAS_HELP_TEXT}
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with help text, with info, with counter, height - 96px, min width - 160px'>
        <TextareaOutlineField
          helpText={TEXTAREAS_HELP_TEXT}
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with info, with counter, height - 96px, min width - 160px'>
        <TextareaOutlineField
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>

      <Container label='Textarea skeleton'>
        <TextareaSkeleton
          withLabel
          className={styles.textareaSkeletonBox}
          textareaClassName={styles.textareaSkeleton}
        />
      </Container>
    </>
  )
}

export default TextareasOutline
